import { useCallback, useEffect, useState } from 'react';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { first } from 'rxjs/operators';
import { IAnonmyousApi } from '@vivli/core/infrastructure/interface';
import { AssignedAppTypeEnum } from '@vivli/shared/infrastructure/enum';

interface IConfigContextHook {
    anonApi: IAnonmyousApi;
    assignedAppType: AssignedAppTypeEnum;
}

export const useTranslations = ({ anonApi, assignedAppType }: IConfigContextHook): boolean => {
    const { getTranslations } = anonApi;
    const [translationsReady, setTranslationsReady] = useState<boolean>(false);

    const handleTranslations = () => {
        if (i18next.isInitialized) {
            return;
        }

        return getTranslations(assignedAppType)
            .pipe(first())
            .subscribe((translation) => {
                i18next.use(initReactI18next).init(
                    {
                        react: {
                            transKeepBasicHtmlNodesFor: ['br', 'strong', 'u', 'p'],
                        },
                        lng: 'en',
                        debug: true,
                        resources: {
                            en: {
                                translation,
                            },
                        },
                    },
                    () => {
                        setTranslationsReady(true);
                    }
                );
            });
    };

    useEffect(() => {
        if (!assignedAppType) {
            return;
        }

        handleTranslations();
    }, [assignedAppType, getTranslations]);

    return translationsReady;
};
